var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{class:[_vm.cssClass, 'font-bold', 'text-xs', 'mt-1']},[_vm._v(_vm._s(_vm.count)+" / "+_vm._s(_vm.limit))])
}
var staticRenderFns = []

export { render, staticRenderFns }